import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBellOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.707 2.293a1 1 0 0 0-1.414 1.414l2.856 2.856C5.051 7.033 5 7.513 5 8c0 2.913-.732 4.844-1.5 6.077l-.011.02c-.358.573-.64 1.027-.83 1.358a5.66 5.66 0 0 0-.247.467c-.032.07-.068.157-.096.251a1.225 1.225 0 0 0-.051.45c.01.136.039.37.173.611.134.242.318.39.428.47.25.186.538.229.634.243h.004c.147.023.315.034.484.04.335.013.799.013 1.376.013h11.222l3.707 3.707a1 1 0 0 0 1.414-1.414L6.997 5.583a.996.996 0 0 0-.066-.066L3.707 2.293Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.604 20.338a1 1 0 0 1 1.412-.088c.53.468 1.222.75 1.984.75.761 0 1.455-.282 1.984-.75a1 1 0 1 1 1.323 1.5A4.985 4.985 0 0 1 12 23a4.985 4.985 0 0 1-3.308-1.25 1 1 0 0 1-.088-1.412ZM21.53 17.288a1.48 1.48 0 0 0 .205-.666 1.224 1.224 0 0 0-.05-.449 1.988 1.988 0 0 0-.097-.251 5.677 5.677 0 0 0-.247-.467c-.19-.33-.472-.784-.83-1.358l-.012-.02C19.732 12.844 19 10.913 19 8A7 7 0 0 0 7.173 2.93l14.358 14.358Z"
    />
  </svg>
);
SvgBellOff01.displayName = 'BellOff01';
export default SvgBellOff01;
